var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileyDrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 7.2069C32 8.70011 30.7076 10 29 10C27.2924 10 26 8.70011 26 7.2069C26 6.35187 26.3926 4.69832 27.0766 3.24329C27.414 2.52549 27.7923 1.92222 28.1736 1.51434C28.5677 1.09263 28.8477 1 29 1C29.1523 1 29.4323 1.09263 29.8264 1.51434C30.2077 1.92222 30.586 2.52549 30.9234 3.24329C31.6074 4.69832 32 6.35187 32 7.2069Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4784 1.85166C21.2466 0.669513 18.7015 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 15.1434 31.9327 14.3025 31.8031 13.4823C31.193 13.719 30.5376 13.8807 29.8516 13.9545C29.9494 14.6222 30 15.3052 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C18.4586 2 20.7691 2.63375 22.7772 3.74681C22.9773 3.12123 23.2124 2.48176 23.4784 1.85166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 15.5C25 14.5717 24.6313 13.6815 23.9749 13.0251C23.3185 12.3687 22.4283 12 21.5 12C20.5717 12 19.6815 12.3687 19.0251 13.0251C18.3687 13.6815 18 14.5717 18 15.5L19.5209 15.5C19.5209 14.9751 19.7294 14.4717 20.1006 14.1006C20.4717 13.7294 20.9751 13.5209 21.5 13.5209C22.0249 13.5209 22.5283 13.7294 22.8994 14.1006C23.2706 14.4717 23.4791 14.9751 23.4791 15.5H25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25 15.5C25 14.5717 24.6313 13.6815 23.9749 13.0251C23.3185 12.3687 22.4283 12 21.5 12C20.5717 12 19.6815 12.3687 19.0251 13.0251C18.3687 13.6815 18 14.5717 18 15.5L19.5209 15.5C19.5209 14.9751 19.7294 14.4717 20.1006 14.1006C20.4717 13.7294 20.9751 13.5209 21.5 13.5209C22.0249 13.5209 22.5283 13.7294 22.8994 14.1006C23.2706 14.4717 23.4791 14.9751 23.4791 15.5H25Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-3-inside-1)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5C13 14.5717 12.6313 13.6815 11.9749 13.0251C11.3185 12.3687 10.4283 12 9.5 12C8.57174 12 7.6815 12.3687 7.02513 13.0251C6.36875 13.6815 6 14.5717 6 15.5L7.51294 15.5C7.51294 14.973 7.72229 14.4676 8.09494 14.0949C8.46758 13.7223 8.973 13.5129 9.5 13.5129C10.027 13.5129 10.5324 13.7223 10.9051 14.0949C11.2777 14.4676 11.4871 14.973 11.4871 15.5H13Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5C13 14.5717 12.6313 13.6815 11.9749 13.0251C11.3185 12.3687 10.4283 12 9.5 12C8.57174 12 7.6815 12.3687 7.02513 13.0251C6.36875 13.6815 6 14.5717 6 15.5L7.51294 15.5C7.51294 14.973 7.72229 14.4676 8.09494 14.0949C8.46758 13.7223 8.973 13.5129 9.5 13.5129C10.027 13.5129 10.5324 13.7223 10.9051 14.0949C11.2777 14.4676 11.4871 14.973 11.4871 15.5H13Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-4-inside-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5497 23.9375C22.8365 22.7022 21.8239 21.6663 20.6052 20.9251C19.3865 20.1839 18.0009 19.7614 16.576 19.6963C15.1511 19.6313 13.7328 19.9259 12.4516 20.553C11.1705 21.1801 10.0677 22.1195 9.24499 23.2846L10.5663 24.2176C11.2325 23.2742 12.1254 22.5135 13.1627 22.0058C14.2001 21.498 15.3485 21.2595 16.5023 21.3121C17.656 21.3648 18.778 21.707 19.7647 22.3071C20.7515 22.9072 21.5714 23.746 22.1489 24.7462L23.5497 23.9375Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.5497 23.9375C22.8365 22.7022 21.8239 21.6663 20.6052 20.9251C19.3865 20.1839 18.0009 19.7614 16.576 19.6963C15.1511 19.6313 13.7328 19.9259 12.4516 20.553C11.1705 21.1801 10.0677 22.1195 9.24499 23.2846L10.5663 24.2176C11.2325 23.2742 12.1254 22.5135 13.1627 22.0058C14.2001 21.498 15.3485 21.2595 16.5023 21.3121C17.656 21.3648 18.778 21.707 19.7647 22.3071C20.7515 22.9072 21.5714 23.746 22.1489 24.7462L23.5497 23.9375Z",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-5-inside-3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyDrop);
export default __webpack_public_path__ + "static/media/smiley-drop.0486e6fb1c5d3f0176fedbf006114dd8.svg";
export { ForwardRef as ReactComponent };